import { Link } from "react-router-dom";
import { Play, Info, Flame } from "lucide-react";
import { resolveMedia } from "../lib/api";

const HERO_FALLBACK = "https://images.unsplash.com/photo-1770328738994-0d9ae1f57edf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxjaW5lbWF0aWMlMjBkYXJrJTIwc3BhY2UlMjBvcmFuZ2UlMjBnbG93fGVufDB8fHx8MTc3ODI2NDcwMXww&ixlib=rb-4.1.0&q=85";

export default function HeroBanner({ video }) {
  const empty = !video;
  const bg = empty ? HERO_FALLBACK : (resolveMedia(video.thumbnail) || HERO_FALLBACK);

  return (
    <section
      data-testid="hero-banner"
      className="relative min-h-[72vh] md:min-h-[88vh] w-full overflow-hidden noise-overlay"
    >
      <div className="absolute inset-0">
        <img src={bg} alt="" className="w-full h-full object-cover scale-110" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/80 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-transparent to-transparent" />
        <div className="absolute inset-0 aura-glow" />
      </div>
      <div className="scan-line" />

      <div className="relative z-10 px-4 sm:px-8 lg:px-20 pt-28 md:pt-40 pb-16 max-w-4xl">
        <div className="flex items-center gap-2 mb-6">
          <span className="inline-flex items-center gap-1.5 text-[10px] font-bold tracking-[0.3em] uppercase text-[#FFB800] border border-[#FFB800]/40 rounded-full px-3 py-1 bg-black/40">
            <Flame className="w-3 h-3" /> {empty ? "Nexus Online" : "Featured"}
          </span>
          <span className="text-xs uppercase tracking-[0.25em] text-zinc-500">SaiyanVictoria · Channel One</span>
        </div>

        <h1 className="text-4xl sm:text-5xl lg:text-7xl font-black tracking-tight text-white aura-text-glow leading-[0.95]">
          {empty ? <>The Nexus<br/><span className="text-[#FF6B00]">Awakens.</span></> : video.title}
        </h1>

        <p className="mt-6 max-w-2xl text-base md:text-lg text-zinc-300 leading-relaxed">
          {empty
            ? "A private, uncensored streaming dimension curated entirely by TheSaiyanVictoria. Long-form features, vertical shorts, and 24-hour stories — pure signal, zero noise."
            : (video.description || "Featured drop — straight from the source.")}
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-3">
          {empty ? (
            <Link
              to="/admin/login"
              data-testid="hero-admin-cta"
              className="aura-button inline-flex items-center gap-2 h-12 px-7 rounded-full text-sm uppercase tracking-wider"
            >
              <Play className="w-4 h-4 fill-current" /> Enter Studio
            </Link>
          ) : (
            <Link
              to={`/watch/${video.id}`}
              data-testid="hero-play-btn"
              className="aura-button inline-flex items-center gap-2 h-12 px-7 rounded-full text-sm uppercase tracking-wider"
            >
              <Play className="w-4 h-4 fill-current" /> Watch Now
            </Link>
          )}
          <Link
            to="/library"
            data-testid="hero-browse-btn"
            className="inline-flex items-center gap-2 h-12 px-7 rounded-full bg-white/5 border border-white/10 hover:border-white/30 text-white text-sm uppercase tracking-wider font-bold transition-colors backdrop-blur"
          >
            <Info className="w-4 h-4" /> Browse Library
          </Link>
        </div>
      </div>
    </section>
  );
}
